

export enum DeliveryType {
  HOME_PRINT_DELIVERY = "HOMEPRINT",
  COBO_DELIVERY = "COBO",
  UPS_DELIVERY = "SECURECOURIER",
  YURTICI_DELIVERY = "DISTANTCOURIER"
}
